// extracted by mini-css-extract-plugin
export default {"balance-pill":"BalancePill-module_balance-pill_CE1oC3","balancePill":"BalancePill-module_balance-pill_CE1oC3"};